import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';

export const loginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const oidc = inject(OidcSecurityService);

  return oidc.isAuthenticated().pipe(take(1), map(isAuth => {
    if (isAuth) {
      router.navigate(['/dashboard']);
    }
    return !isAuth;
  }));
};
